export default "__VITE_ASSET__Dn9GWB3F__"